module.exports = __webpack_public_path__ + "static/media/reports.ff7066d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/reports.png
// module id = 1105
// module chunks = 0